import classNames from "classnames";
import { DComponent } from "../../../../components/DComponent";
import { GLOBAL_CONSTANTS } from "../../../../global/constants";
import { Address } from "../../../../models/Address";

export default class AddressItem extends DComponent {
  constructor({
    parent,
    id,
    className = "",
    address = new Address(),
    selectedId,
    isSelect,
    isReadOnly,
    hideIcon,
    hideRemove = false,
    isRFQInfo = false,
    isModal = false,
    onRemove = () => { },
    onEdit = () => { },
    onSelect = () => { },
    isLoading = false
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("AddressItem", className, {
        "is-primary": address.addressType === GLOBAL_CONSTANTS.ADDRESS_TYPE.PRIMARY,
        "is-select": isSelect,
        "is-readonly": isReadOnly,
        "hide-icon": hideIcon,
        "hide-delete": hideRemove,
        "is-rfq-info": isRFQInfo,
        "is-modal": isModal,
        "is-loading": isLoading
      }),
      addressId: address.id || "",
      name: address.firstName ? address.firstName + "&nbsp;•&nbsp;" : "",
      phone: address.phoneNumber || "",
      address: address?.getAdressFull && address.getAdressFull(),
      email: address.email || "",
      classRadio: selectedId === address.id ? " active" : ""
    }, true);
    this.address = address;
    this.onRemove = onRemove;
    this.onEdit = onEdit;
    this.onSelect = onSelect;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "AddressItem");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.addEvent();
  }

  /**
   * 
   * @param {Address} address 
   */
  fillData(address = new Address()) {
    this.address = address;
    $(".value.id", this.element).text(address.id);
    $(".value.name", this.element).html(address.firstName ? address.firstName + "&nbsp;•&nbsp;" : "");
    $(".value.phone", this.element).text(address.phoneNumber || "");
    $(".value.email", this.element).text(address.email || "");
    $(".value.address", this.element).text(address.getAdressFull());
    if (address.addressType === GLOBAL_CONSTANTS.ADDRESS_TYPE.PRIMARY) {
      this.element.addClass("is-primary");
    } else {
      this.element.removeClass("is-primary");
    }
  }

  addEvent() {
    $(".btn-remove", this.element).on("click", (e) => {
      typeof this.onRemove == "function" && this.onRemove(this.address.id);
    })

    $(".btn-edit", this.element).on("click", (e) => {
      typeof this.onEdit == "function" && this.onEdit(this.address.id);
    })

    $(".radio", this.element).on("click", (e) => {
      $(".radio", this.element).addClass("active");
      typeof this.onSelect == "function" && this.onSelect(this.address.id);
    })
  }

  setSelected() {
    $(".radio", this.element).removeClass("active");
  }

  getSelected() {
    return !!$(".radio.active", this.element).length;
  }

  getAddress() {
    return this.address;
  }
}